// extracted by css-extract-rspack-plugin
export default {"instructionalText":"_6d6cde81"};